// The demo board (David, 26 Oct 2026): board.contextbolt.com/demo opens a sample workspace for anyone, with no account.
// What it shows comes from public/demo-board.json (scripts/demo-build.mjs makes it); every change stays in this tab, in
// memory, and is gone on reload. Nothing in the demo reaches the board's server: api() answers it (src/demo/api.ts), the
// save queue never sends, and no socket opens.

/** Whether this page is the demo. Read once: the app never changes its own path. */
export const DEMO = typeof location !== "undefined" && /^\/demo\/?$/.test(location.pathname);

/** Where people go to start a board of their own, tagged so the landing page's analytics can count the demo's visitors. */
export const START_URL = "https://contextbolt.com/board/?utm_source=board-demo&utm_medium=demo&utm_campaign=demo-board";

/** What a step the demo cannot take says, wherever the app shows a refusal. */
export const DEMO_REFUSAL = "That works on your own board. This demo keeps nothing.";
